import Vue from 'vue'
import Router from 'vue-router'
import VueMeta from 'vue-meta'
import Pongo from '../views/pongo'
import Home from '../views/home'
import Index from '../views/index'
import DigitalTwins from '../views/digital_twins'
import Dock from '../views/dock'
import Create from '../views/create'
import Energy from '../views/energy'
import Factory from '../views/factory'
import Models from '../views/models'
import ModelsDetail from '../views/models_details/index_test_shadow.vue'
import Help from '../views/help/index.vue'
import About from '../views/about'
import User from '../views/user'
import UserInformation from '../views/user/infomation'
import UserModels from '../views/user/my_model'
import UserProjects from '../views/user/my_project'
import UserSubscribe from '../views/user/my_subscribe'
import UserUpload from '../views/user/upload'
import UserEditModel from '../views/user/edit/indx.vue'
import Advice from '../views/advice'
import News from '../views/news'
import Share from '../views/share'
import ChangePwd from '../views/changePwd'
import UpdateFirst from '../views/updateFirst'
import NotFound from '../views/error/404.vue'
import { wxLogin } from '../util/index'
import { Message } from 'element-ui'
import { baseUrl } from '../util/constant'
import store from '../store/index'
import qs from 'qs'
import { getPageEnd, getPageStart } from '../util/index'

let visitedTime = Date.now()
let totalTime = 0
let isPageVisible = true

Vue.use(Router)
Vue.use(VueMeta)

const router =  new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/index',
      component: Home,
      children: [
        {
          path: 'index',
          name: 'index',
          component: Index
        },
        {
          path: 'about',
          name: 'about',
          component: About
        },
        {
          path: 'help',
          name: 'help',
          component: Help
        },
        {
          path: 'pongo',
          name: 'pongo',
          component: Pongo
        },
        {
          path: 'digital_twin',
          name: 'digital_twin',
          component: DigitalTwins,
        },
        {
          path: 'create',
          name: 'create',
          component: Create,
        },
        {
          path: 'dock',
          name: 'dock',
          component: Dock,
        },
        {
          path: 'factory',
          name: 'factory',
          component: Factory,
        },
        {
          path: 'energy',
          name: 'energy',
          component: Energy,
        },
        {
          path: '/models',
          name: 'models',
          component: Models
        },
        {
          path: '/models_detail',
          name: 'models_detail',
          component: ModelsDetail
        },
        // {
        //   path: '/test',
        //   name: 'test',
        //   component: Test
        // },
      ]
    },
    {
      path: '/404',
      name: '404',
      component: NotFound,
    },
    {
      path: '/changePwd',
      name: 'changePwd',
      component: ChangePwd
    },
    {
      path: '/updateFirst',
      name: 'UpdateFirst',
      component: UpdateFirst
    },
    {
      path: '/news',
      name: 'news',
      component: News
    },
    {
      path: '/share',
      name: 'share',
      component: Share
    },
    {
      path: '/advice',
      name: 'advice',
      component: Advice,
    },
    {
      path: '/user',
      name: 'user',
      component: User,
      redirect: '/user/user_info',
      children:[
        {
          path: 'user_info',
          name: 'user_info',
          component: UserInformation,
        },
        {
          path: 'user_model',
          name: 'user_model',
          component: UserModels,
        },
        {
          path: 'user_project',
          name: 'user_project',
          component: UserProjects,
        },
        {
          path: 'user_sub',
          name: 'user_sub',
          component: UserSubscribe,
        },
        {
          path: 'user_upload',
          name: 'user_upload',
          component: UserUpload,
        },
        {
          path: 'user_edit',
          name: 'user_edit',
          component: UserEditModel,
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  }
})

// 解决重复点击导航时，控制台出现报错  ---亦可在跳转时做判断
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

router.beforeEach(async (to, from, next) => {

  // const wx_url =window.location.href;  
  // const parseUrl = qs.parse(wx_url.split('?')[1]);
  // console.log(wx_url);
  // var reject_url_wx = "";
  // var reject_code_query = parseUrl.code;
  // //这一步就是第二步所说的存在本地的验证码的信息，这里的操作就是如果有验证码并且有微信回调的code,那就进入当前的页面，如果没有那就进入正常的路由
  // let wx_code_url = localStorage.getItem("QRCODEWX");
  // if (wx_code_url == null) {
  //   reject_url_wx = "";
  // }else{
  //   if (parseUrl.code && parseUrl.state) { 
  //     reject_url_wx = `/user/user_info?${qs.stringify(parseUrl)}`;
  //   }else{   
  //     reject_url_wx = "";
  //   }
  // }

  document.documentElement.scrollTop = 0;

  if(to.query.code === undefined) {
    console.log('未定义');
    // const token = window.sessionStorage.getItem('token')
    // if(token) {
    //   next('/login')
    // } else {
      next()
    // }
  } else {
    let code = to.query.code
    console.log(to);
    if (to.path === "/user/user_info") {
       next()
       return
    }
    // let code = '001NLB100T7W7T1zxn200KIvQK3NLB1P'
    let codeObj = {
      // code: to.query.code,
      code,
    }
    wxLogin(codeObj).then(res => {
      console.log(res);
      if (res.code === 200) {
        console.log('扫码登录成功');
        if(res.data.status === 2){
          console.log('新用户或者未完善个人信息',res);
          Message.success('请先完善个人信息')
          window.localStorage.setItem('userToken',res.data.accessToken);
          window.localStorage.setItem('refreshToken', res.data.refreshToken);
          next('/updateFirst')
        }else if(res.data.status === 1){
          Message.success('扫码登录成功')
          window.localStorage.setItem('userToken',res.data.accessToken);
          window.localStorage.setItem('refreshToken', res.data.refreshToken);
          // window.localStorage.setItem('userName',res.data.openId);
          Vue.prototype.$bus.$emit('changeUserInfo', null)
          // 刷新页面
          window.history.replaceState({}, document.title, window.location.pathname);
          // next('/')
        }else{
          // 禁用
          Message.error('账号已被禁用')
        }
      } else {
        console.log('出问题了');
        Message.error('扫码登录失败')
      }
    })
    // callBack(code)
  }
  if(to.path === '/user/user_info' && from.path === '/user/user_info'){
    console.log(to);
  }
  try {
      // 调用接口，记录访问开始
      let token = window.localStorage.getItem('userToken')
      if(to.path === '' || to.path === '/' || to.path === '/index'){
         getPageStart(token, {home: true})
      }else{
        getPageStart(token, {})
      }
      visitedTime = Date.now(); // 记录访问开始时间
      next(); // 继续路由导航
  } catch (error) {
      console.error("访问记录失败:", error);
      next(); // 继续路由导航，即使请求失败
  }
  try {
    // 请求 API 获取 SEO 数据
    const response = await fetch(baseUrl + `/tdk`);
    console.log(response);

    // if (response.code !== 200) {
    //   console.error('Network response was not ok:', response.message);
    //   return; // 如果响应不成功，提前返回
    // }

    const seoData = await response.json(); // 正确解析 JSON

    // 动态设置页面的 title 和 meta
    setTimeout(() => {
      if (seoData) {
        document.title = seoData.data.title || '默认标题'; // 设定默认值
        updateMetaTag('description', seoData.data.description || '默认描述'); // 设定默认值
        updateMetaTag('keywords', seoData.data.keywords || '默认关键词'); // 设定默认值
        console.log('成功获取 SEO 数据');
      } else {
        console.warn('没有获取到 SEO 数据');
      }
    }, 500);

    next();
  } catch (error) {
    console.error('Error fetching SEO data:', error);
    next(); // 确保即使请求失败也能导航到目标页面
  }
})

function updateMetaTag(name, content) {
  let element = document.querySelector(`meta[name="${name}"]`);
  if (element) {
    element.setAttribute('content', content);
  } else {
    element = document.createElement('meta');
    element.setAttribute('name', name);
    element.setAttribute('content', content);
    document.head.appendChild(element);
  }
}

// 页面加载时监听 visibilitychange 事件
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "hidden") {
      // 页面变为不可见状态，暂停计时
      if (isPageVisible) {
          const now = Date.now();
          totalTime += Math.floor((now - visitedTime) / 1000); // 累加当前停留时间
          isPageVisible = false;
      }
  } else {
      // 页面重新可见，重新开始计时
      visitedTime = Date.now();
      isPageVisible = true;
  }
});

window.addEventListener('beforeunload', async () => {
  if(isPageVisible) {
    const now = Date.now();
    totalTime += Math.floor((now - visitedTime) / 1000); // 累加当前停留时间
  }
  // const visitEndTime = Date.now();
  // const seconds = Math.floor((visitEndTime - visitedTime) / 1000); // 计算停留时间（秒）

  try {
      // 调用接口，记录访问结束
      let token = window.localStorage.getItem('userToken')
      getPageEnd(token, {seconds: totalTime});
  } catch (error) {
      console.error("退出记录失败:", error);
  }
});

router.afterEach((to, from) => {
  visitedTime = Date.now();
  isPageVisible = true;
});

// router.beforeEach((to, from, next) => {
//   if (to.path === '/login') {
//     next();
//   } else {
//     let token = localStorage.getItem('token');
//   }
// })


export default router